export const PARALLEL_UPLOADS = 3;
